import { ɵɵelementContainer, ɵɵelementStart, ɵɵtemplate, ɵɵelementEnd, ɵɵnextContext, ɵɵreference, ɵɵadvance, ɵɵproperty, ɵɵnamespaceSVG, ɵɵelement, ɵɵelementContainerStart, ɵɵelementContainerEnd, ɵɵgetCurrentView, ɵɵlistener, ɵɵrestoreView, ɵɵattribute, ɵɵdefineComponent, ɵɵProvidersFeature, forwardRef, ɵɵNgOnChangesFeature, ɵɵtemplateRefExtractor, ɵsetClassMetadata, Component, ChangeDetectionStrategy, ViewEncapsulation, Input, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgForOf, NgIf, NgTemplateOutlet, CommonModule } from '@angular/common';

function NgxInputStarRatingComponent_button_1_span_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function NgxInputStarRatingComponent_button_1_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 6);
    ɵɵtemplate(1, NgxInputStarRatingComponent_button_1_span_1_ng_container_1_Template, 1, 0, "ng-container", 7);
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵnextContext(2);
    const _r1 = ɵɵreference(3);
    ɵɵadvance(1);
    ɵɵproperty("ngTemplateOutlet", _r1);
} }
function NgxInputStarRatingComponent_button_1_ng_container_2_span_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function NgxInputStarRatingComponent_button_1_ng_container_2_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 10);
    ɵɵtemplate(1, NgxInputStarRatingComponent_button_1_ng_container_2_span_1_ng_container_1_Template, 1, 0, "ng-container", 7);
    ɵɵnamespaceSVG();
    ɵɵelementStart(2, "svg", 11);
    ɵɵelement(3, "polygon", 12);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵnextContext(3);
    const _r1 = ɵɵreference(3);
    ɵɵadvance(1);
    ɵɵproperty("ngTemplateOutlet", _r1);
} }
function NgxInputStarRatingComponent_button_1_ng_container_2_span_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function NgxInputStarRatingComponent_button_1_ng_container_2_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 13);
    ɵɵtemplate(1, NgxInputStarRatingComponent_button_1_ng_container_2_span_2_ng_container_1_Template, 1, 0, "ng-container", 7);
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵnextContext(3);
    const _r1 = ɵɵreference(3);
    ɵɵadvance(1);
    ɵɵproperty("ngTemplateOutlet", _r1);
} }
function NgxInputStarRatingComponent_button_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, NgxInputStarRatingComponent_button_1_ng_container_2_span_1_Template, 4, 1, "span", 8);
    ɵɵtemplate(2, NgxInputStarRatingComponent_button_1_ng_container_2_span_2_Template, 2, 1, "span", 9);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const btn_r3 = ɵɵnextContext().$implicit;
    const ctx_r6 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", btn_r3.icon === ctx_r6.starIcons.half);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", btn_r3.icon !== ctx_r6.starIcons.full && btn_r3.icon !== ctx_r6.starIcons.half);
} }
function NgxInputStarRatingComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 3);
    ɵɵlistener("click", function NgxInputStarRatingComponent_button_1_Template_button_click_0_listener() { ɵɵrestoreView(_r14); const i_r4 = ctx.index; const ctx_r13 = ɵɵnextContext(); return ctx_r13.rate(i_r4); })("mouseenter", function NgxInputStarRatingComponent_button_1_Template_button_mouseenter_0_listener() { ɵɵrestoreView(_r14); const i_r4 = ctx.index; const ctx_r15 = ɵɵnextContext(); return ctx_r15.mouseEnter(i_r4); });
    ɵɵtemplate(1, NgxInputStarRatingComponent_button_1_span_1_Template, 2, 1, "span", 4);
    ɵɵtemplate(2, NgxInputStarRatingComponent_button_1_ng_container_2_Template, 3, 2, "ng-container", 5);
    ɵɵelementEnd();
} if (rf & 2) {
    const btn_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r0 = ɵɵnextContext();
    ɵɵproperty("disabled", ctx_r0.disabled);
    ɵɵattribute("aria-label", "rate " + (i_r4 + 1) + " of " + ctx_r0.buttons.length);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", btn_r3.active || btn_r3.icon === ctx_r0.starIcons.full);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !btn_r3.active);
} }
function NgxInputStarRatingComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵnamespaceSVG();
    ɵɵelementStart(0, "svg", 14);
    ɵɵelement(1, "polygon", 12);
    ɵɵelementEnd();
} }
const starIcons = {
    outline: 'outline',
    full: 'full',
    half: 'half',
};
class NgxInputStarRatingComponent {
    constructor() {
        this._value = 0;
        this.count = 5;
        this.disabled = false;
        this.starIcons = starIcons;
        this.buttons = [];
        // tslint:disable-next-line:no-empty
        this.onChange = (_value) => { };
        // tslint:disable-next-line:no-empty
        this.onTouched = () => { };
    }
    get value() {
        return this._value;
    }
    set value(val) {
        this._value = val;
        this.onChange(val);
        this.valueUpdate(this._value);
        this.onTouched();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    writeValue(value) {
        if (value !== this.value) {
            this.value = value;
        }
    }
    ngOnInit() {
        for (let i = 0; i < this.count; i++) {
            this.buttons.push({ active: false, icon: starIcons.outline });
        }
        this.valueUpdate(this.value);
    }
    ngOnChanges(changes) {
        if (changes.value && changes.value.currentValue) {
            this.valueUpdate(changes.value.currentValue);
        }
    }
    rate(index) {
        this.buttons.forEach((btn, i) => {
            if (i <= index) {
                btn.icon = starIcons.full;
            }
            else {
                btn.icon = starIcons.outline;
            }
        });
        const total = this.buttons.reduce((prev, next) => {
            if (next.icon === starIcons.full) {
                return prev + 1;
            }
            else {
                return prev;
            }
        }, 0);
        this.value = total;
    }
    mouseEnter(index) {
        this.buttons.forEach((btn, i) => {
            if (i <= index) {
                btn.active = true;
            }
            else {
                btn.active = false;
            }
        });
    }
    mouseLeave() {
        this.buttons.forEach((i) => (i.active = false));
    }
    valueUpdate(value) {
        this.buttons.forEach((btn, i) => {
            const starValue = i + 1;
            if (value >= starValue) {
                btn.icon = starIcons.full;
            }
            if (value >= starValue - 0.5 && value < starValue) {
                btn.icon = starIcons.half;
            }
        });
    }
}
NgxInputStarRatingComponent.ɵfac = function NgxInputStarRatingComponent_Factory(t) { return new (t || NgxInputStarRatingComponent)(); };
NgxInputStarRatingComponent.ɵcmp = ɵɵdefineComponent({ type: NgxInputStarRatingComponent, selectors: [["ngx-input-star-rating"]], inputs: { _value: ["value", "_value"], count: "count", disabled: "disabled" }, features: [ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => NgxInputStarRatingComponent),
                multi: true,
            },
        ]), ɵɵNgOnChangesFeature], decls: 4, vars: 1, consts: [[1, "ngx-input-rating", 3, "mouseleave"], ["type", "button", "class", "ngx-input-rating__btn", "class", "ngx-input-star-rating__btn", 3, "disabled", "click", "mouseenter", 4, "ngFor", "ngForOf"], ["star", ""], ["type", "button", 1, "ngx-input-star-rating__btn", 3, "disabled", "click", "mouseenter"], ["class", "ngx-input-star-rating__full", 4, "ngIf"], [4, "ngIf"], [1, "ngx-input-star-rating__full"], [4, "ngTemplateOutlet"], ["class", "ngx-input-star-rating__half", 4, "ngIf"], ["class", "empty", 4, "ngIf"], [1, "ngx-input-star-rating__half"], ["height", "25", "width", "10", 1, "ngx-input-star-rating__star-half"], ["points", "9.9, 1.1, 3.3, 21.78, 19.8, 8.58, 0, 8.58, 16.5, 21.78", 2, "fill-rule", "nonzero"], [1, "empty"], ["height", "25", "width", "23", 1, "ngx-input-star-rating__star"]], template: function NgxInputStarRatingComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵlistener("mouseleave", function NgxInputStarRatingComponent_Template_div_mouseleave_0_listener() { return ctx.mouseLeave(); });
        ɵɵtemplate(1, NgxInputStarRatingComponent_button_1_Template, 3, 4, "button", 1);
        ɵɵelementEnd();
        ɵɵtemplate(2, NgxInputStarRatingComponent_ng_template_2_Template, 2, 0, "ng-template", null, 2, ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngForOf", ctx.buttons);
    } }, directives: [NgForOf, NgIf, NgTemplateOutlet], styles: ["*,:after,:before{box-sizing:border-box}ngx-input-star-rating{--color-star-default:#ccc;--color-star-highlight:#3d3d3d;display:inline-block}.ngx-input-star-rating__star{fill:#ccc;fill:var(--color-star-default)}.ngx-input-star-rating__btn{background-color:initial;border:0;cursor:pointer;height:25px;position:relative;width:30px}.ngx-input-star-rating__btn svg{left:5px;position:absolute;top:0}.ngx-input-star-rating__full .ngx-input-star-rating__star,.ngx-input-star-rating__half .ngx-input-star-rating__star-half{fill:#3d3d3d;fill:var(--color-star-highlight)}"], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(NgxInputStarRatingComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-input-star-rating',
                templateUrl: './ngx-input-star-rating.component.html',
                styleUrls: ['./ngx-input-star-rating.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => NgxInputStarRatingComponent),
                        multi: true,
                    },
                ],
                encapsulation: ViewEncapsulation.None,
            }]
    }], null, { _value: [{
            type: Input,
            args: ['value']
        }], count: [{
            type: Input
        }], disabled: [{
            type: Input
        }] }); })();

class NgxInputStarRatingModule {
}
NgxInputStarRatingModule.ɵmod = ɵɵdefineNgModule({ type: NgxInputStarRatingModule });
NgxInputStarRatingModule.ɵinj = ɵɵdefineInjector({ factory: function NgxInputStarRatingModule_Factory(t) { return new (t || NgxInputStarRatingModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(NgxInputStarRatingModule, { declarations: [NgxInputStarRatingComponent], imports: [CommonModule], exports: [NgxInputStarRatingComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(NgxInputStarRatingModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [NgxInputStarRatingComponent],
                exports: [NgxInputStarRatingComponent],
            }]
    }], null, null); })();

/*
 * Public API Surface of ngx-input-star-rating
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxInputStarRatingComponent, NgxInputStarRatingModule };
//# sourceMappingURL=ngx-lite-input-star-rating.js.map
